export enum FourriereSort {
  'RAISON_SOCIALE' = 'RAISON_SOCIALE',
  'CODE_POSTAL' = 'CODE_POSTAL',
  'COMMUNE' = 'COMMUNE',
  'RAISON_SOCIALE_DNID' = 'RAISON_SOCIALE_DNID',
}
